if (!customElements.get("quick-add-modal")) {
	customElements.define(
		"quick-add-modal",
		class QuickAddModal extends ModalDialog {
			constructor() {
				super();
				this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
			}

			hide(preventFocus = false) {
				const cartDrawer = document.querySelector("cart-drawer");
				if (cartDrawer) cartDrawer.setActiveElement(this.openedBy);
				
				// 清理颜色选择器事件监听器
				this.cleanupColorSwatchEvents();
				
				this.modalContent.innerHTML = "";

				$(".js-media-list").each(function () {
					this.swiper.destroy();
				});
				$(".js-media-sublist").each(function () {
					this.swiper.destroy();
				});

				subSliderInit(true);
				sliderInit(true);
				updatethumbnail();

				if (preventFocus) this.openedBy = null;
				super.hide();
			}

			show(opener) {
				opener.setAttribute("aria-disabled", true);
				opener.classList.add("loading");

				this.addEventListener(
					"transitionend",
					() => {
						const containerToTrapFocusOn = document.getElementById(
							opener.getAttribute("data-modal-open")
						);
						const focusElement = this.querySelector(".modal-close-button");
						trapFocus(containerToTrapFocusOn, focusElement);
					},
					{ once: true }
				);

				if (opener.querySelector(".loading-overlay__spinner")) {
					opener
						.querySelector(".loading-overlay__spinner")
						.classList.remove("hidden");
				}

				fetch(opener.getAttribute("data-product-url"))
					.then((response) => response.text())
					.then((responseText) => {
						const responseHTML = new DOMParser().parseFromString(
							responseText,
							"text/html"
						);
						this.productElement = responseHTML.querySelector(
							'section[id^="MainProduct-"]'
						);
						this.preventDuplicatedIDs();
						this.removeDOMElements();
						this.setInnerHTML(
							this.modalContent,
							this.productElement.innerHTML,
							opener
						);

						if (window.Shopify && Shopify.PaymentButton) {
							Shopify.PaymentButton.init();
						}

						if (window.ProductModel) window.ProductModel.loadShopifyXR();

						this.removeGalleryListSemantic();
						this.updateImageSizes();
						this.preventVariantURLSwitching();
						super.show(opener);

						// 触发quick view打开事件
						this.dispatchEvent(new CustomEvent('quickview:opened', {
							detail: { modal: this }
						}));

						// 初始化quick view中的颜色选择器
						this.initializeQuickViewVariantGroup();

						$(".product-form__input--dropdown").each(function () {
							const elListItem = $(this).find(".dropdown-select ul li");
							const elItem = $(this).find(".dropdown-select ul");
							const selectedText = $(this).find(
								".dropdown-select .select-label"
							);

							selectedText.on("click", function (e) {
								elItem.toggleClass("active");
								if (elItem.hasClass("active")) {
									e.stopPropagation();
									$(document).click(function () {
										elItem.removeClass("active");
									});
								}
							});

							elListItem.on("click", function () {
								selectedText.text($(this).text()).attr("title", $(this).text());
								elItem.removeClass("active");
								document.activeElement.blur();
							});
						});
					})
					.finally(() => {
						opener.removeAttribute("aria-disabled");
						opener.classList.remove("loading");

						if (opener.querySelector(".loading-overlay__spinner")) {
							opener
								.querySelector(".loading-overlay__spinner")
								.classList.add("hidden");
						}

						document.querySelector("cart-drawer").classList.remove("active");

						subSliderInit();
						sliderInit();
						updatethumbnail();
					});
			}

			setInnerHTML(element, html, opener) {
				element.innerHTML = html;

				// Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
				element.querySelectorAll("script").forEach((oldScriptTag) => {
					const newScriptTag = document.createElement("script");
					Array.from(oldScriptTag.attributes).forEach((attribute) => {
						newScriptTag.setAttribute(attribute.name, attribute.value);
					});
					newScriptTag.appendChild(
						document.createTextNode(oldScriptTag.innerHTML)
					);
					oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
				});
			}

			removeDOMElements() {
				const pickupAvailability = this.productElement.querySelector(
					"pickup-availability"
				);
				if (pickupAvailability) pickupAvailability.remove();

				const productModal = this.productElement.querySelector("product-modal");
				if (productModal) productModal.remove();

				const gift = this.productElement.querySelector(".customer");
				if (gift) gift.remove();
			}

			preventDuplicatedIDs() {
				const sectionId = this.productElement.dataset.section;
				this.productElement.innerHTML =
					this.productElement.innerHTML.replaceAll(
						sectionId,
						`quickadd-${sectionId}`
					);
				this.productElement
					.querySelectorAll("variant-selects, variant-radios")
					.forEach((variantSelect) => {
						variantSelect.dataset.originalSection = sectionId;
					});
			}

			preventVariantURLSwitching() {
				if (this.modalContent.querySelector("variant-radios,variant-selects")) {
					this.modalContent
						.querySelector("variant-radios,variant-selects")
						.setAttribute("data-update-url", "false");
				}
			}

			removeGalleryListSemantic() {
				const galleryList = this.modalContent.querySelector(
					'[id^="Slider-Gallery"]'
				);
				if (!galleryList) return;

				galleryList.setAttribute("role", "presentation");
				galleryList
					.querySelectorAll('[id^="Slide-"]')
					.forEach((li) => li.setAttribute("role", "presentation"));
			}

			updateImageSizes() {
				const product = this.modalContent.querySelector(".product");
				const desktopColumns = product.classList.contains("product--columns");
				if (!desktopColumns) return;

				const mediaImages = product.querySelectorAll(".product__media img");
				if (!mediaImages.length) return;

				let mediaImageSizes =
					"(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)";

				if (product.classList.contains("product--medium")) {
					mediaImageSizes = mediaImageSizes.replace("715px", "605px");
				} else if (product.classList.contains("product--small")) {
					mediaImageSizes = mediaImageSizes.replace("715px", "495px");
				}

				mediaImages.forEach((img) =>
					img.setAttribute("sizes", mediaImageSizes)
				);
			}

			initializeQuickViewVariantGroup() {
				// 等待内容完全加载
				setTimeout(() => {
					const productElement = this.modalContent.querySelector('.product');
					if (!productElement) return;

					// 确保颜色选择器元素存在
					const colorLabels = productElement.querySelectorAll('label.color-swatch, label.option-Size');
					if (colorLabels.length === 0) {
						// 如果还没有颜色选择器，再等待一下
						setTimeout(() => {
							this.handleQuickViewDefaultSelection(productElement);
							this.bindQuickViewColorSwatchEvents(productElement);
						}, 100);
					} else {
						this.handleQuickViewDefaultSelection(productElement);
						this.bindQuickViewColorSwatchEvents(productElement);
					}
				}, 300);
			}

			handleQuickViewDefaultSelection(productElement) {
				const checkedInput = productElement.querySelector('input[type="radio"][checked]');
				if (checkedInput) {
					const checkedLabel = productElement.querySelector(`label[for="${checkedInput.id}"]`);
					if (checkedLabel) {
						const labelTitle = checkedLabel.getAttribute('title');
						this.updateQuickViewMediaDisplay(productElement, labelTitle);
					}
				}
			}

			bindQuickViewColorSwatchEvents(productElement) {
				// 移除之前的事件监听器（避免重复绑定）
				const existingLabels = productElement.querySelectorAll('label.color-swatch, label.option-Size');
				existingLabels.forEach(label => {
					// 移除所有可能的点击事件监听器
					if (this.boundColorSwatchHandler) {
						label.removeEventListener('click', this.boundColorSwatchHandler);
					}
				});

				// 创建绑定的事件处理器
				this.boundColorSwatchHandler = (event) => {
					const label = event.currentTarget;
					const labelTitle = label.getAttribute('title');
					console.log('Quick View 颜色选择器点击:', labelTitle); // 调试信息
					this.updateQuickViewMediaDisplay(productElement, labelTitle);
				};

				// 绑定新的事件监听器
				const colorLabels = productElement.querySelectorAll('label.color-swatch, label.option-Size');
				console.log('找到可选标签数量:', colorLabels.length); // 调试信息
				colorLabels.forEach(label => {
					label.addEventListener('click', this.boundColorSwatchHandler);
				});
			}

			updateQuickViewMediaDisplay(productElement, labelTitle) {
				// 检查是否存在匹配的媒体元素
				// ✅ UPDATED: Use startsWith so alt text like "Blush Fei and Eve Classic Harness"
				// still matches a variant named "Blush"
				const mediaElements = productElement.querySelectorAll('[data-media-alt]');
				const hasMatchingMedia = Array.from(mediaElements)
					.some(element => {
						const mediaAlt = element.getAttribute('data-media-alt');
						return mediaAlt && mediaAlt.startsWith(labelTitle);
					});

				// 处理对应的媒体元素
				mediaElements.forEach(element => {
					const mediaAlt = element.getAttribute('data-media-alt');
					if (hasMatchingMedia) {
						// ✅ UPDATED: Use startsWith instead of === for partial match
						if (mediaAlt && mediaAlt.startsWith(labelTitle)) {
							element.style.display = 'block';
							element.classList.remove('swiper-slide-hidden');
							element.classList.add('swiper-slide');
						} else {
							element.style.display = 'none';
							element.classList.add('swiper-slide-hidden');
							element.classList.remove('swiper-slide');
						}
					} else {
						// 如果没有匹配的媒体元素，显示所有元素
						element.style.display = 'block';
						element.classList.remove('swiper-slide-hidden');
						element.classList.add('swiper-slide');
					}
				});

				// 更新 Swiper 实例
				this.updateQuickViewSwiperInstances(productElement);
			}

			updateQuickViewSwiperInstances(productElement) {
				const swiperElements = productElement.querySelectorAll('.swiper');
				swiperElements.forEach(swiperEl => {
					if (swiperEl.swiper) {
						swiperEl.swiper.update();
						swiperEl.swiper.slideTo(0, 0);
					}
				});
			}

			cleanupColorSwatchEvents() {
				// 清理颜色选择器事件监听器
				if (this.boundColorSwatchHandler) {
					const colorLabels = this.modalContent.querySelectorAll('label.color-swatch, label.option-Size');
					colorLabels.forEach(label => {
						label.removeEventListener('click', this.boundColorSwatchHandler);
					});
					this.boundColorSwatchHandler = null;
				}
			}
		}
	);
}